import { render, staticRenderFns } from "./user-selector.vue?vue&type=template&id=df17b3f6&scoped=true"
import script from "./user-selector.vue?vue&type=script&lang=ts"
export * from "./user-selector.vue?vue&type=script&lang=ts"
import style0 from "./user-selector.vue?vue&type=style&index=0&id=df17b3f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df17b3f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df17b3f6')) {
      api.createRecord('df17b3f6', component.options)
    } else {
      api.reload('df17b3f6', component.options)
    }
    module.hot.accept("./user-selector.vue?vue&type=template&id=df17b3f6&scoped=true", function () {
      api.rerender('df17b3f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/_components/user-selector/user-selector.vue"
export default component.exports